import { useFormikContext } from 'formik';
import map from 'lodash/map';
import { useEffect } from 'react';
import { FC } from 'react';
import { usePrevious } from 'react-use';
import { PurchasesState } from '../Purchases.type';

interface InstantSubmitProps {
    onChange: (value: PurchasesState) => void;
}

export const InstantSubmit: FC<InstantSubmitProps> = ({ onChange }) => {
    const { values, setFieldValue } = useFormikContext<PurchasesState>();
    const prevValues = usePrevious(values);

    const isEqA = (a: any, b: any, key: string) => {
        return a[key] === b[key];
    };

    const isEqB = (a: any, b: any, key: string) => {
        return String(a[key]) === String(b[key]);
    };

    const isEqC = (a: any, b: any, key: string, prop: string) => {
        return (
            map(a[key], prop).sort().join(',') ===
            map(b[key], prop).sort().join(',')
        );
    };

    useEffect(() => {
        if (prevValues && values !== prevValues) {
            if (
                !isEqA(values, prevValues, 'search') ||
                !isEqC(values, prevValues, 'region', 'regionCode') ||
                !isEqC(values, prevValues, 'okpd2', 'code') ||
                !isEqC(values, prevValues, 'section', 'name') ||
                !isEqC(values, prevValues, 'tariff', 'id') ||
                !isEqC(values, prevValues, 'block', 'id') ||
                !isEqC(values, prevValues, 'procedureTemplate', 'id') ||
                !isEqB(values, prevValues, 'publishedFrom') ||
                !isEqB(values, prevValues, 'publishedTo') ||
                !isEqB(values, prevValues, 'receiveStartFrom') ||
                !isEqB(values, prevValues, 'receiveStartTo') ||
                !isEqB(values, prevValues, 'receiveFinishFrom') ||
                !isEqB(values, prevValues, 'receiveFinishTo') ||
                !isEqA(values, prevValues, 'startPriceFrom') ||
                !isEqA(values, prevValues, 'startPriceTo') ||
                !isEqC(values, prevValues, 'procedure', 'id') ||
                !isEqA(values, prevValues, 'freeParticipation') ||
                !isEqA(values, prevValues, 'sortBy') ||
                !isEqA(values, prevValues, 'sectionOrg') ||
                !isEqA(values, prevValues, 'sortOrder')
            ) {
                if (values.page !== 1) {
                    setFieldValue('page', 1);
                } else {
                    onChange(values);
                }
            }
            if (values.page !== prevValues.page) {
                onChange(values);
            }
        }
    }, [onChange, values, prevValues, setFieldValue]);

    return null;
};
